import "./elements";
import "./logger";
import { flow } from "./flow";
import { loadDatalayer } from "./utils/loadDatalayer";
import { getLoggerEventPayload, postLoggerEventDetails } from "./utils/nifiLogger";
import { envConfig } from "./config/envConfigs";
import { azureTokenInfo } from "./utils/azureTokenInfo";

const sleep = (milliseconds: number) => {
  const date = Date.now();
  let currentDate = null;
  do {
    currentDate = Date.now();
  } while (currentDate - date < milliseconds);
};

window.onload = async () => {
  if (!localStorage.getItem("submitButton")) {
    await postLoggerEventDetails("R360_Anticipated_Visits_UI_Launch", "Retail_BusinessTransaction");
  }
};

const handleUnload = async () => {
  const reqPayload = {
    ConsumerId: "Retail360",
    LogType: "Retail_BusinessTransaction",
    TransactionId: sessionStorage.getItem("ev_sessionId")
      ? `${sessionStorage.getItem("ev_sessionId")}_${Math.random().toString(36).substr(2, 15)}`
      : Math.random().toString(36).substr(2, 15),
    eventName: "R360_Anticipated_Visits_UI_Exit",
    kv: getLoggerEventPayload(),
    timestamp: new Date().toISOString(),
  };

  fetch(`${envConfig.urls.exitEvent}`, {
    body: JSON.stringify(reqPayload),
    headers: {
      AuthType: "AzureAD",
      Authorization: `Bearer ${(await azureTokenInfo).access_token}`,
      "Content-Type": "application/json",
    },
    keepalive: true,
    method: "POST",
  });
  sessionStorage.removeItem("ev_exit");
  sessionStorage.removeItem("ev_itgName");
  sessionStorage.removeItem("ev_itgNumber");
  sessionStorage.removeItem("ev_sessionId");
  sessionStorage.removeItem("ev_status");
  sessionStorage.removeItem("ev_stepId");
  sessionStorage.removeItem("ev_pageName");
  sessionStorage.removeItem("ev_submitButton");
  sessionStorage.removeItem("ev_locationId");
  sessionStorage.removeItem("ev_statusCode");
  sessionStorage.removeItem("ev_existingUser");
  sleep(2000);
};

window.onunload = async (event) => {
  if (sessionStorage.getItem("ev_isExistingUserClick") !== "true") {
    event.preventDefault();
    handleUnload();
    event.returnValue = true;
  }
};

loadDatalayer();
flow();

if (import.meta.env.DEV) {
  (async () => {
    const { startAxe } = await import("./utils/axe");
    startAxe();
  })();
}
